var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, createElement } from 'react';
const SimpleTextHtmlRenderer = (props) => {
    const { data } = props;
    const Text = (_a) => {
        var { tagName = "div" } = _a, props = __rest(_a, ["tagName"]);
        const htmlEl = useRef(null);
        const elementProps = Object.assign(Object.assign({}, props), { ref: htmlEl });
        return createElement(tagName, elementProps);
    };
    const content = data === null || data === void 0 ? void 0 : data.content;
    const type = data === null || data === void 0 ? void 0 : data.textType;
    const style = data === null || data === void 0 ? void 0 : data.style;
    const css = data === null || data === void 0 ? void 0 : data.css;
    const styleString = style ? style : "";
    const cssString = css ? css : "";
    let styleObj = undefined;
    if (style && style !== "") {
        try {
            styleObj = JSON.parse(styleString);
        }
        catch (error) {
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { tagName: type, className: cssString, style: styleObj }, content)));
};
export default SimpleTextHtmlRenderer;
//# sourceMappingURL=SimpleTextHtmlRenderer.js.map